/** Mermaid source for the email pipeline guide (flowchart TB). */

export const EMAIL_PIPELINE_OVERVIEW_CHART = `
flowchart TB
  subgraph prepare["① Prepare"]
    NL["Newsletter<br/>edit content, audience, send time"]
    MAT["Materialize<br/>Schedule send or Send now"]
    SE[("scheduled_emails<br/>one row per subscriber · status pending")]
    NL --> MAT --> SE
  end

  subgraph ai["② AI optional · runs before send"]
    PERS["Personalize worker<br/>every 15 minutes"]
    SE --> PERS
    PERS -.->|"writes tuned subject & body"| SE
  end

  subgraph deliver["③ Deliver when due"]
    SEND["Send worker<br/>every 5 minutes"]
    GATE{"Due and<br/>AI finished?"}
    PM["Postmark<br/>template + layout"]
    SE --> SEND --> GATE
    GATE -->|yes| PM
    GATE -->|"no · retry next tick"| WAIT["Stays pending"]
  end

  subgraph done["④ Complete"]
    ROW["Row: sent, failed, or canceled"]
    PUB["Newsletter → Published<br/>when all rows done"]
    PM --> ROW --> PUB
  end

  subgraph track["⑤ Tracking feedback async"]
    TRK["Postmark open/click webhooks"]
    EVT[("email_engagement_events")]
    PM -.->|"TrackOpens + TrackLinks"| TRK
    TRK --> EVT
  end

  ROW -.->|"postmark_message_id"| TRK
`;

export const SEND_STATUS_LIFECYCLE_CHART = `
stateDiagram-v2
  direction LR
  [*] --> pending: materialize / schedule

  pending --> sending: send worker claims row
  pending --> canceled: unsubscribed or automation cancel
  pending --> pending: cron skips (AI not ready)

  sending --> sent: Postmark OK
  sending --> failed: API or validation error

  failed --> pending: admin retry (clears error)
  canceled --> pending: admin override (rare)

  sent --> [*]
  canceled --> [*]
`;

export const SEND_CRON_QUERY_CHART = `
flowchart LR
  TICK["Cron tick<br/>every 5 min"] --> Q["Query pending rows"]
  Q --> C{"scheduled_at<br/>≤ now?"}
  C -->|yes| B["Up to 50 oldest rows"]
  B --> AI{"personalization<br/>blocking?"}
  AI -->|no| POST["Postmark send"]
  AI -->|yes| SKIP["Skip until next tick"]
  C -->|no| FUTURE["Not yet due"]
`;
